'use strict';

/*

  Example:

  {
    value: '1',
    text: 'option 1'
  }

*/

function getOption(opts) {
  return {
    tag: 'option',
    attrs: {
      disabled: opts.disabled,
      value: opts.value
    },
    children: opts.text,
    key: opts.value
  };
}

module.exports = getOption;




//////////////////
// WEBPACK FOOTER
// ./~/tcomb-form/~/uvdom-bootstrap/lib/getOption.js
// module id = 280
// module chunks = 0